import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { INDUSTRIES } from "@/data/site";
import { GlowOrb } from "@/components/common/GlowOrb";
import Seo from "@/components/seo/Seo";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <Seo title="Industries We Build Software For" description="Software, AI and mobile app development across education, healthcare, government, construction, retail and more."/>
      <section className="relative overflow-hidden py-20 md:py-28">
        <GlowOrb className="top-0 right-0" color="accent" size={500} />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-primary mb-4">Industries</div>
          <h1 className="font-heading font-black tracking-tighter text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-[0.95]">
            Industry-Focused AI and <span className="text-gradient-aurora">Software Development Solutions</span>
          </h1>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {INDUSTRIES.map((ind) => {
            const Icon = Icons[ind.icon] || Icons.Layers;
            return (
              <Link
                to={`/industries/${ind.slug}`}
                key={ind.slug}
                className="glass rounded-2xl p-6 hover:border-primary/50 hover:-translate-y-1 transition-[transform,border-color] duration-300"
                data-testid={`industries-page-card-${ind.slug}`}
              >
                <Icon className="w-6 h-6 text-primary" />
                <div className="mt-4 font-heading font-bold text-lg">{ind.name}</div>
                <p className="mt-1 text-xs text-muted-foreground">{ind.blurb}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
